import HTTPClient from './http-client';

const options = {
  cache: {
    maxAge: 24 * 60 * 60 * 1000,
    exclude: { query: false }
  }
}

const END_POINT = '/radar/mosaico/titan/L4/geral/surv/nc/latest/MSC_TITAN_PPI_L4_1.nc?item=layerDetails&request=GetMetadata&';

const loadMetadata = async (LAYERS) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}layerName=${LAYERS}`,
    options
  );
}

export {
  loadMetadata
}
